import { ConfiguracionFicha } from 'src/app/compartido/ficha/utilidades/ficha.models';
import { ConfiguracionTablaSincrona } from 'src/app/compartido/tabla/utilidades/tabla.models';
import { Icono } from 'src/app/compartido/utilidades/compartido.static';

/* Encabezados del Excel de Evedisa 22 */
export const ENCABEZADOS_EXCEL_EVEDISA_22: string[] = [
  'Despacho',
  'SSC',
  'Llave',
  'Nombre',
  'Dirección',
  'Sucursal-Ciudad',
  'Teléfono',
  'Recaudo',
  'Medicamento',
  'Fecha',
  'Tipo Domicilio',
  'Cantidad',
  'Tipo',
  'Departamento',
  'Ciudad',
  'Sucursal-Ciudad 2',
  'Fijo',
  'Celular',
  'Teléfono Audifarma',
];

/* Configuración de la ficha de Evedisa 22 */
export const CONFIGURACION_FICHA_EVEDISA_22: ConfiguracionFicha = {
  header: { titulo: 'Crear Órdenes', icono: Icono.ORDENES },
};

/* Configuración de la tabla de Evedisa 22 */
export const CONFIGURACION_TABLA_EVEDISA_22: ConfiguracionTablaSincrona = {
  columnas: ENCABEZADOS_EXCEL_EVEDISA_22.map((encabezado) => ({
    slug: encabezado,
    nombre: encabezado,
  })),
  acciones: [
    {
      slug: 'quitar',
      nombre: 'Quitar Fila',
      icono: Icono.ELIMINAR,
    },
  ],
};
